define('SageDotCom/DataLayer/Events/feedback-interaction',[
    "SageDotCom/DataLayer/Events/eventBase"
], function (EventBase) {

    function FeedbackInteractionEvent(el) {
        EventBase.call(this);
        
        this.props = {
            "event_name": "feedback",
            "event_non-int ": "0",
            "event_category": "component",
            "event_action": "feedback",
            "event_label": "start",
            "event_name_level_1": this.getId(el),
            "event_name_level_2": "0%",
            "event_name_level_3": "uz_popup_modal",
            "event_name_level_4": this.getLanguage()
        };
    }

    FeedbackInteractionEvent.prototype = Object.create(EventBase.prototype);

    return FeedbackInteractionEvent;
});
